import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import ReplyComment from './ReplyComment';
import {
  makeSelectLoadingReply,
  makeSelectLoading,
  makeSelectComments,
} from './selectors';
import { postLikeComment } from './actions';
import {
  makeSelectProfile,
  makeSelectIsAuthenticated,
} from '../AuthProvider/selectors';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import Avatar from '~/components/Avatar';
import Link from '~/components/I18nLink';
import themeVariables from '~/shared/themeVariables';

const Comment = ({
  comment,
  appendReplyCommentData,
  loadingReply,
  idCommentClick,
  setIdCommentClick,
  idReplyClick,
  setIdReplyClick,
  t,
  profile,
  postLikeComment,
}) => {
  const [isOpenFormReply, setIsOpenFormReply] = useState(false);
  const [isLoadingReply, setIsLoadingReply] = useState(false);
  // const [idReplyClick, setIdReplyClick] = useState(null);

  useEffect(() => {
    if (idCommentClick === comment?.id && loadingReply) {
      setIsLoadingReply(true);
    } else {
      setIsLoadingReply(false);
    }
  }, [loadingReply, comment, idCommentClick]);

  const openReplyComment = (id) => {
    setIdCommentClick(id);
    if (comment?.countReply > 0) {
      appendReplyCommentData({
        data_id: comment.object_id,
        comment_id: id,
      });
    }
    setIsOpenFormReply(true);
  };
  const likeComment = (comment_id) => {
    postLikeComment({
      comment_id: comment_id,
      user_id: profile.id,
      data_id: comment.object_id,
    });
  };
  const handleHiddenInforEmail = (email) => {
    const array = email.split('@');
    const lengthData = array[0].length;
    const start = array[0].slice(0, lengthData / 4);
    const end = array[0].slice((lengthData / 4) * 3 + 1, lengthData);
    return start + '*****' + end + array[1];
  };
  const name = comment?.name || '';
  let email = handleHiddenInforEmail(comment?.email || '');

  return (
    <div className="container-item-comment">
      <div className="container-avatar">
        {comment?.is_creator ? (
          <Link href={`/creator-profile/${comment.user_id}`}>
            <Avatar src={comment?.avatar} size={56} />
          </Link>
        ) : (
          <Avatar src={comment?.avatar} size={56} />
        )}
      </div>
      <div className="media-body">
        <div className="container-comment-content">
          <div className="row">
            <div className="col-md-12">
              <div className="media-heading">
                <div className="name-header">
                  {comment?.is_creator ? (
                    <Link href={`/creator-profile/${comment?.user_id}`}>
                      {name || email}
                    </Link>
                  ) : (
                    name || email
                  )}
                </div>
                <div className="date-comment">
                  {moment.unix(comment?.created_at).fromNow()}
                </div>
              </div>
            </div>
          </div>
          <div className="content-comment">{comment?.text}</div>
        </div>
        <div className="container-action">
          <div
            className={`button-like ${
              comment?.likeActive ? 'active-like' : ''
            } `}
            onClick={() => likeComment(comment?.id)}
          >
            {t('text_like_comment')}{' '}
            {comment?.count_like > 0 && `(${comment?.count_like})`}
          </div>
          <div
            className={`button-reply ${
              comment?.countReply > 0 && 'active-reply'
            }`}
            onClick={() => openReplyComment(comment?.id)}
          >
            {t('text_reply_commen')}{' '}
            {comment?.countReply > 0 && `(${comment?.countReply})`}
          </div>
        </div>
        {/* {comment.dataReply && <ReplyComment />} */}

        {isLoadingReply ? (
          <LoadingSpinner style={{ padding: '40px 0' }} />
        ) : (
          (comment.dataReply || isOpenFormReply) && (
            <ReplyComment
              isOpenFormReply={isOpenFormReply}
              idReplyClick={idReplyClick}
              setIdReplyClick={setIdReplyClick}
              commentID={comment?.id || null}
              comment={comment}
              t={t}
            />
          )
        )}
      </div>
      <style jsx>{`
        .container-item-comment {
          display: flex;
          gap: 16px;
        }
        .button-like {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #170507;
          padding: 8px;
          display: inline-block;
        }
        .button-like.active-like {
          font-weight: 700;
          font-size: 14px;
          color: ${themeVariables.colors.primary};
        }
        .button-like:hover {
          text-decoration: underline !important;
          cursor: pointer;
        }
        .button-reply {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #170507;
          padding: 8px;
          display: inline-block;
        }
        .button-reply:hover {
          text-decoration: underline !important;
          cursor: pointer;
        }
        .active-reply {
          font-weight: 700;
          font-size: 14px;
          color: #170507;
        }
        .media-heading {
          display: flex;
          gap: 24px;
        }
        .name-header {
          font-weight: 700;
          font-size: 16px;
          line-height: 28px;
          color: #3a4ed7;
        }
        .date-comment {
          display: flex;
          flex-direction: column;
          justify-content: center;
          space-between: center;
          font-weight: 500;
          font-size: 16px;
          color: #7a7a7a;
        }
        .container-action {
          display: flex;
        }
      `}</style>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  loadingReply: makeSelectLoadingReply(),
  comments: makeSelectComments(),
  loading: makeSelectLoading(),
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
});

const mapDispatchToProps = (dispatch) => ({
  postLikeComment: (params) => dispatch(postLikeComment(params)),
});

const Connector = connect(mapStateToProps, mapDispatchToProps)(Comment);

export default Connector;
